import { faPlus } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Col, Row } from "react-bootstrap";
import { useFieldArray } from "react-hook-form";
import { AddFullButton } from "../components/buttons/addFullButton";
import { availableQuestionTypes } from "../support/availableQuestionTypes";
import { RegistrationFormProps } from "../types/registrationFormTypes";
import { RegistrationFormSection } from "./RegistrationFormSection/RegistrationFormSection";

export const RegistrationForm = ({ register, errors, control, getValues }: RegistrationFormProps) => {
    const {
        fields: sectionFields,
        append: appendSection,
        remove: removeSection,
        insert: insertSection,
        move
    } = useFieldArray({ control, name: "sections" });

    const addSection = (): void => {
        appendSection({
            name: "",
            questions: [
                {
                    name: '',
                    type: availableQuestionTypes[0],
                    description: '',
                    isRequired: true,
                    isHiddenFromReviwers: false,
                    options: [],
                }
            ]
        });
    }

    const duplicateSection = (index: number) => {
        const currentValues = getValues(`sections.${index}`);
        insertSection(index + 1, currentValues);
    };

    const onDragEnd = (result: any) => {
        if (!result.destination) return;
        move(result.source.index, result.destination.index);
    };

    useEffect(() => {
        if (sectionFields.length === 0) {
            addSection();
        }
    }, [sectionFields, addSection])

    return (
        <span className="d-flex flex-column background-transparent">
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="sections-droppable">
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>

                            {sectionFields.map((sectionField, sectionIndex) => (
                                <Draggable
                                    key={sectionField.id}
                                    draggableId={String(sectionField.id)}
                                    index={sectionIndex}
                                >
                                    {(drag) => (
                                        <div
                                            ref={drag.innerRef}
                                            {...drag.draggableProps}
                                            {...drag.dragHandleProps}
                                            className="mb-3"
                                        >
                                            <RegistrationFormSection
                                                sectionId={String(sectionField.id)}
                                                sectionIndex={sectionIndex}
                                                control={control}
                                                register={register}
                                                errors={errors}
                                                getValues={getValues}
                                                onDelete={() => removeSection(sectionIndex)}
                                                onDuplicate={() => duplicateSection(sectionIndex)}
                                            />
                                        </div>
                                    )}
                                </Draggable>
                            ))}

                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
            <Row className="mt-4">
                <Col>
                    <AddFullButton label="Adicionar seção" icon={faPlus} handleOnClick={addSection} />
                </Col>
            </Row>
        </span>
    );
};
